import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { Wrapper, DivNum } from './styles';
import NoticeModal from './NoticeModal';
import noticeApi from 'api/noticeApi';
import {
    setHaveUnreadMessage,
    setNoticeDetail,
    setNoticeList,
    clearNoticeDetail,
} from './noticeSlice';

const NoticeBox = () => {
    const dispatch = useDispatch();
    const [showNotice, setShowNotice] = useState(false);
    const haveUnreadMessage = useSelector((state) => Number(state.notice.haveUnreadMessage || 0));
    const noticeList = useSelector((state) => state.notice.noticeList || []);
    const noticeDetail = useSelector((state) => state.notice.noticeDetail);

    const handleClick = (notice) => {
        dispatch(setNoticeDetail(notice));
    }
    const handleDialogClose = () => {
        dispatch(clearNoticeDetail());
        setShowNotice(false);
    }

    useEffect(() => {
        (async function GetNotice() {
            if (!showNotice) return;
            try {
                const { data } = await noticeApi.GetNotice();
                const noticeListData = data || [];
                dispatch(setNoticeList(noticeListData));
                const unreadCount = Array.isArray(noticeListData)
                    ? noticeListData.reduce((count, item) => count + (item.IsSeen < 1 ? 1 : 0), 0)
                    : 0;
                if (unreadCount >0 && haveUnreadMessage > 0) {
                    return;
                }
                dispatch(setHaveUnreadMessage(unreadCount));
            } catch (error) {
                console.error('Error fetching notice:', error);
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showNotice,dispatch]);

    useEffect(() => {
        (async function UpdateReadMessage() {
            if (!noticeDetail || noticeDetail.IsSeen > 0) return;
            try {
                const { data } = await noticeApi.UpdateSeen(noticeDetail.WebClientMessageID);
                const noticeListData = data || [];
                dispatch(setNoticeList(noticeListData));
                const temp = Array.isArray(noticeListData)
                    ? noticeListData.reduce((count, item) => count + (!item.IsSeen ? 1 : 0), 0)
                    : 0;
                dispatch(setHaveUnreadMessage(temp));
            } catch (error) {
                console.error('Error fetching notice:', error);
            }
        })();
    }, [dispatch, noticeDetail?.WebClientMessageID, noticeDetail]);

    return (
        <>
            <Wrapper onClick={() => { setShowNotice(true); }}>
                <FontAwesomeIcon icon={faBell} />
                {haveUnreadMessage > 0 && <DivNum />}
            </Wrapper>
            {!!showNotice && <NoticeModal noticeList={noticeList}
                handleDialogClose={handleDialogClose}
                noticeDetail={noticeDetail}
                handleClick={(notice) => handleClick(notice)}
            />}
        </>
    )
}


export default NoticeBox
